<template>
  <div class="wrapper">
    <section
      class="row back_white_contact mb-3 mx-3 mt-3"
      :class="isRTL ? 'rtl' : ''"
    >
      <div class="col-12 d-flex justify-content-center">
        <h3 class="static_title">{{ $t("GET_IN_TOUCH") }}</h3>
      </div>

      <form class="row" @submit.prevent="validateBeforeSubmit">
        <div
          class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center flex-column"
        >
          <div class="d-flex justify-content-center">
            <input
              v-model="FirstName"
              name="FirstName"
              type="text"
              :placeholder="$t('FIRST_NAME')"
              v-validate="{ required: true, min: 3 }"
              class=""
            />
          </div>

          <div class="d-flex justify-content-center">
            <span class="text-danger " v-show="errors.has('FirstName')"
              >{{ errors.first("FirstName") }}
            </span>
          </div>
        </div>

        <div
          class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center flex-column"
        >
          <div class="d-flex justify-content-center">
            <input
              v-model="LastName"
              type="text"
              name="LastName"
              :placeholder="$t('LAST_NAME')"
              v-validate="{ required: true, min: 3 }"
            />
          </div>
          <div class="d-flex justify-content-center">
            <span class="text-danger" v-show="errors.has('LastName')">{{
              errors.first("LastName")
            }}</span>
          </div>
        </div>

        <div
          class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center flex-column"
        >
          <div class="d-flex justify-content-center">
            <input
              v-model="Email"
              name="email"
              type="email"
              :placeholder="$t('EMAIL')"
              v-validate="'required|email'"
              class=""
            />
          </div>

          <div class="d-flex justify-content-center">
            <span class="text-danger " v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>
        </div>

        <div
          class="contact-phone-input col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center flex-column"
        >
          <!-- <div class="col-3 px-0">
            <input
              v-model="MobilePrefix"
              class="new_number"
              name="prefix"
              type="number"
              placeholder="+91"
              v-validate="'required|numeric'"
            />
            <span class="text-danger" v-show="errors.has('prefix')">{{
              $t("ENTER_COUNTRY_CODE")
            }}</span>
          </div>
          <div class="col-6 px-0">
            <input
              v-model="MobileNumber"
              class="new_number"
              type="number"
              name="mobileNumber"
              :placeholder="$t('MOBILE_NUMBER')"
              v-validate="'required|numeric'"
            />
            <span class="text-danger" v-show="errors.has('mobileNumber')">{{
              $t("VAILD_NUMBER")
            }}</span>
          </div> -->
          <VuePhoneNumberInput
            v-model="mobile"
            :default-country-code="
              countryList.find(o => o.phonecode == countryCode) &&
                countryList.find(o => o.phonecode == countryCode).isoCode
            "
            @update="onKeyUp($event, 'mobile')"
            id="phoneNumber1"
          />
        </div>

        <div class="col-12 mt-3 pl-xl-5">
          <b-form-checkbox
            id="checkbox-1"
            v-model="status"
            name="checkbox-1"
            value="accepted"
            unchecked-value="not_accepted"
            class="pl-5"
          >
            {{ $t("EVENT_ORGANISER") }}
          </b-form-checkbox>

          <input
            :class="status == 'accepted' ? 'd-block mt-3 mx-auto' : 'd-none'"
            type="text"
            :placeholder="$t('COMPANY_NAME')"
            v-model="companyName"
          />
          <span class="text-danger" v-if="status && companyName.length > 4">{{
            $t("ENTER_COMPANY_NAME")
          }}</span>
        </div>

        <div class="col-12 mt-3 d-flex justify-content-center">
          <textarea
            v-model="Comments"
            class="textarea_new col-11"
            :placeholder="$t('QUESTION_COMMENTS')"
            rows="4"
            cols="50"
          >
          </textarea>
        </div>

        <div class="col-12 mt-3 d-flex justify-content-center">
          <input type="submit" :value="$t('SUBMIT')" />
        </div>
      </form>

      <!--Error Modal-->
      <div class="error_modal">
        <b-modal
          id="bv-modal-example"
          ref="Error-modal"
          hide-footer
          hide-header
          content-class="error_modal"
        >
          <div
            class="d-flex align-item-center justify-content-center text-center"
          >
            <img src="@/assets/img/icons/warning.svg" width="6%" class="mr-2" />
            <h3 class="mb-0">Fill the required field</h3>
          </div>
          <!-- <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Close Me</b-button> -->
        </b-modal>
      </div>

      <!--Error Modal-->

      <!--Sucess Modal-->
      <div class="error_modal">
        <b-modal
          id="bv-modal-example"
          ref="Success-modal"
          hide-footer
          hide-header
          content-class="success_modal"
        >
          <div
            class="d-flex align-item-center justify-content-center text-center"
          >
            <img
              src="@/assets/img/icons/check-tick.svg"
              width="6%"
              class="mr-2"
            />
            <h3 class="mb-0">Your Form Have Been Submitted</h3>
          </div>
          <!-- <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Close Me</b-button> -->
        </b-modal>
      </div>

      <!--Sucess Modal Ends-->

      <div class="col-12 mt-5 border-top">
        <div class="row pt-3">
          <div
            class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex align-items-center flex-column mb-lg-2 mb-md-2 mb-sm-2 mb-xs-2"
          >
            <img src="@/assets/img/icons/envelope.svg" class="contact_img" />
            <h4 class="text-capitalize contact_heading mt-2">
              {{ $t("REACH_US") }}
            </h4>
            <a href="mailto:hello@wanasatime.com" style="color:#ff2349;"
              >hello@wanasatime.com</a
            >
          </div>

          <div
            class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex align-items-center flex-column mb-lg-2 mb-md-2 mb-sm-2 mb-xs-2"
          >
            <img src="@/assets/img/icons/call.svg" class="contact_img" />
            <h4 class="text-capitalize contact_heading mt-2">
              {{ $t("CONTACT") }}
            </h4>
            <a href="tel:+973 13633334 " style="color:#ff2349;"
              >+973 13633334</a
            >
            <a href="mailto:hello@wanasatime.com" style="color:#ff2349;"
              >hello@wanasatime.com</a
            >
            <p class="text-center">
              {{ $t("SMSCOUNTRY") }}
            </p>
          </div>

          <div
            class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex align-items-center flex-column mb-lg-2 mb-md-2 mb-sm-2 mb-xs-2"
          >
            <img src="@/assets/img/icons/message.svg" class="contact_img" />
            <h4 class="text-capitalize contact_heading mt-2">
              {{ $t("FOLLOW_US") }}
            </h4>
            <div class="d-flex" style="gap:10px">
              <a
                href="https://www.facebook.com/wanasatimebahrain/"
                target="_blank"
              >
                <img
                  src="@/assets/img/icons/facebook.svg"
                  class="icons_contact"
                />
              </a>
              <a
                href="https://www.instagram.com/wanasatimebahrain/"
                target="_blank"
              >
                <img
                  src="@/assets/img/icons/instagram.svg"
                  class="icons_contact"
                />
              </a>
              <a
                href="https://www.youtube.com/channel/UCGFYBcAvN-nRdNedByeDKdg "
                target="_blank"
              >
                <img
                  src="@/assets/img/icons/youtube.svg"
                  class="icons_contact"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { makeRequest } from "@/helper/internet.js";
import { runInThisContext } from "vm";
import { mapGetters } from "vuex";
import countryCodes from "@/helper/countryCodes.js";
import VuePhoneNumberInput from "vue-phone-number-input";
import { TokenService, CountryService } from "@/services/storage.service";

export default {
  components: {
    VuePhoneNumberInput
  },
  data() {
    return {
      FirstName: "",
      LastName: "",
      Email: "",
      countryList: countryCodes,
      MobilePrefix: "",
      countryCode: "",
      MobileNumber: "",
      Comments: "",
      status: false,
      submitStatus: false,
      companyName: "",
      inputData: {
        FirstName: "",
        LastName: "",
        Email: "",
        MobilePrefix: "",
        MobileNumber: ""
      },
      errorMsg: {
        FirstName: "",
        LastName: "",
        Email: "",
        MobilePrefix: "",
        MobileNumber: "",
        CompanyName: ""
      }
    };
  },
  mounted() {
    let countryData = CountryService.getCountry();
    this.countryCode = countryData.CountryISOCode;
  },
  beforeMount() {
    metaInfo.title = "Contact us - Wanasatime Bahrain";
    metaInfo.meta[2].content =
      "Have queries regarding online ticket booking, discount and coupons, show timing, ticket delivery, and more? Contact us!";
    metaInfo.meta[3].content = "contact us, Wanasatime";
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.showLoading();
          let payload = {
            FirstName: this.FirstName,
            LastName: this.LastName,
            Email: this.Email,
            CountryCode: this.MobilePrefix,
            Phone: this.MobileNumber,
            IsEventOrg: this.status == true ? "1" : "0",
            CompanyName: this.CompanyName,
            Message: this.Comments,
            Latitude: -1,
            Longitude: -1,
            LanguageID: 1,
            CountryID: "113"
          };

          makeRequest("/ContactUs", "POST", null, payload)
            .then(response => {
              const { error, res } = response;
              if (res.data.Status) {
                this.successModal();
                this.FirstName = "";
                this.LastName = "";
                this.Email = "";
                this.MobilePrefix = "";
                this.MobileNumber = "";
                this.status = false;
                this.CompanyName = "";
                this.Comments = "";
              } else {
                //this.contactUsDetails.errorMessage = res.data.Message;
              }
              this.hideLoading();
            })
            .catch(error => {
              this.hideLoading();
            });
        } else {
          this.hideLoading();
          this.errorModal();
        }
      });
      this.hideLoading();
      // alert("Errors!");
    },
    successModal() {
      this.$refs["Success-modal"].show();
      setTimeout(() => {
        this.$refs["Success-modal"].hide();
      }, 2000);
    },
    errorModal() {
      // let hideError = this.$refs['Error-modal'].hide()
      this.$refs["Error-modal"].show();
      setTimeout(() => {
        this.$refs["Error-modal"].hide();
      }, 2000);
    }
  },

  computed: {
    ...mapGetters(["isRTL"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/contact.vue